import React, { useContext } from 'react';
import { Box } from '@mui/material';
import BalanceSummaryTable from './BalanceSummaryTable';
import { useTranslation } from 'react-i18next';
import { ReportContext } from '../../../../common/reportContext';
import { AverageBalanceDetail } from '../../../../networking/analyses/report/CashBoard.types';
import PaperSection from '../../../../components/PaperSection/PaperSection';

interface BalanceSummaryProps {
  selectedAccountGroupIndex: number;
}

const getDateRangeString = (averageBalanceDetail: AverageBalanceDetail) => {
  const start = new Date(averageBalanceDetail.startDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC'
  });
  const end = new Date(averageBalanceDetail.endDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC'
  });
  return `${start} - ${end}`;
};

const BalanceSummary = (props: BalanceSummaryProps) => {
  const { t } = useTranslation();
  const { report } = useContext(ReportContext);

  const averageBalances =
    report.cashBoard.yearOverYearChange[props.selectedAccountGroupIndex].averageBalances;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' }, gap: 4 }}>
      <PaperSection variant="plain"
        title={t('cashVestAnalyses.cashBoard.ttmBalanceTitle', {
          reportDate: getDateRangeString(averageBalances.trailingTwelveMonthsAverageBalance)
        })}
      >
        <BalanceSummaryTable
          previousYear={averageBalances.trailingTwelveMonthsAverageBalance.previous}
          currentYear={averageBalances.trailingTwelveMonthsAverageBalance.current}
          difference={averageBalances.trailingTwelveMonthsAverageBalance.difference}
        />
      </PaperSection>

      <PaperSection variant="plain"
        title={t('cashVestAnalyses.cashBoard.averageBalanceTitle', {
          reportDate: getDateRangeString(averageBalances.periodAverageBalance)
        })}
      >
        <BalanceSummaryTable
          previousYear={averageBalances.periodAverageBalance.previous}
          currentYear={averageBalances.periodAverageBalance.current}
          difference={averageBalances.periodAverageBalance.difference}
        />
      </PaperSection>
    </Box>
  );
};

export default BalanceSummary;
